/* global jQuery, gform_ppcp_entry_strings */
/* eslint-disable camelcase */

window.GFPPCPEntryActions = null;

( function( $ ) {
	window.GFPPCPEntryActions = function() {
		const self = this;

		self.init = function() {
			self.handleButtonClick();
		};

		/**
		 * Handles Payment details buttons clicks.
		 *
		 * Sends an ajax request to execute the required api action.
		 *
		 * @since 2.0
		 *
		 */
		self.handleButtonClick = function() {
			$( '.ppcp-payment-action' ).on( 'click', function() {
				const $spinner = jQuery( '#ppcp_ajax_spinner' );
				const $button = jQuery( this );
				const api_action = $button.attr( 'data-api-action' );

				if ( 'refund' === api_action && ! confirm( gform_ppcp_entry_strings.refund_confirmation ) ) {
					return false;
				}

				$spinner.show();
				$button.prop( 'disabled', true );

				jQuery.ajax( {
					url: gform_ppcp_entry_strings.ajaxurl,
					method: 'POST',
					data: {
						action: 'gfppcp_payment_details_action',
						nonce: gform_ppcp_entry_strings.payment_details_action_nonce,
						entry_id: $button.data( 'entry-id' ),
						api_action: $button.data( 'api-action' ),
					},
					success( response ) {
						if ( ! ( 'success' in response ) ) {
							alert( gform_ppcp_entry_strings.payment_details_action_error );
							return;
						}
						if ( response.success ) {
							window.location.reload();
						} else {
							alert( response.data.message );
						}
					},
					error() {
						alert( gform_ppcp_entry_strings.payment_details_action_error );
					},
					complete() {
						$spinner.hide();
						$button.prop( 'disabled', false );
					},
				} );
			} );
		};

		self.init();
	};

	$( document ).ready( window.GFPPCPEntryActions );
}( jQuery ) );
